import { render, staticRenderFns } from "./leftWarnList.vue?vue&type=template&id=47a572cc&scoped=true&"
import script from "./leftWarnList.vue?vue&type=script&lang=js&"
export * from "./leftWarnList.vue?vue&type=script&lang=js&"
import style0 from "./leftWarnList.vue?vue&type=style&index=0&id=47a572cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a572cc",
  null
  
)

export default component.exports